import React, { useState, useEffect } from "react";
import {
    Grid,
    Box,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
    Tooltip,
    CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomSnackbar from "../../../CustomSnackbar";
import TableSkeleton from "../../../StyledComponents/TableSkeleton";
import EmptyData from "../../../StyledComponents/Table/EmptyData";
import Card from "../../../StyledComponents/Card/Card";
import CardBody from "../../../StyledComponents/Card/CardBody";
import StampDutyModal from "./StampDutyModal";
import { getRefrenceDataList } from "../AdminSetting/adminaction";

const useStyles = makeStyles(dashboardStyle);

const StampDutySetting = () => {
    const matches = useMediaQuery("(max-width:700px)");
    const classes = useStyles();

    const [getdata, setGetData] = useState([]);
    const [openModel, setOpenModel] = useState(false);
    const [updateId, setUpdateId] = useState("");
    const [deleteId, setDeleteID] = useState(false);
    const [togglebutton, settogglebutton] = useState("");
    const [getdataFromID, setGetDataFromID] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [searchApi, setSearchAPi] = useState([]);
    const [Loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        getRefrenceDataList(
            "Province",
            setGetData,
            setSearchAPi,
            setLoading,
            () => { },
            () => { },
            () => { },
            () => { }
        );
    }, []);

    const handleSearchInput = (e) => {
        const inputValue = e.target.value;
        setSearchInput(inputValue);
        if (inputValue === "") {
            setGetData(searchApi);
        } else {
            const filterData = searchApi.filter((data) =>
                data?.referenceText?.toLowerCase().includes(inputValue.toLowerCase())
            );

            if (filterData.length > 0) {
                setGetData(filterData);
            } else {
                setGetData([{ message: "No Records Found" }]);
            }
        }
    };

    return (
        <>
            <Card style={{ marginTop: "10px" }}>
                <CardBody>
                    <Grid container spacing={2} pb={2}>
                        <Grid item xs={6} sm={6} md={4} lg={4} mt={-2}>
                            <TextField
                                size="small"
                                sx={{ "& .MuiInputBase-root": { height: 30 } }}
                                fullWidth
                                placeholder="Search here..."
                                variant="outlined"
                                type="search"
                                value={searchInput}
                                onChange={handleSearchInput}
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} md={8} lg={8} mt={-2}>
                            <Box display="flex" justifyContent="end">
                                <Button
                                    variant="contained"
                                    size="small"
                                    color="secondary"
                                    sx={{
                                        color: "#fff",
                                        fontSize: matches ? "10px" : "15px",
                                        height: 30,
                                        width: matches ? "117px" : "151px",
                                    }}
                                    onClick={() => {
                                        setOpenModel(true);
                                        setDeleteID("");
                                        settogglebutton("");
                                    }}
                                >
                                    Add New Item
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>

                    <TableContainer className="scrollable" sx={{ height: 400 }}>
                        <Table
                            className={classes.table}
                            size="small"
                            sx={{ height: "max-content" }}
                        >
                            <TableHead style={{ position: "sticky", top: "0px" }}>
                                <TableRow sx={{ backgroundColor: "#A5ACB0" }}>
                                    <TableCell  sx={{ fontWeight: "bold", color: "#fff" }}>S#</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: "bold", color: "#fff" }}>Province</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: "bold", color: "#fff" }}>Stamp Duty</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: "bold", color: "#fff" }}>
                                        Action
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getdata.map((item, index) => (
                                    <>
                                        {item.message ? (
                                            <TableRow>
                                                <TableCell colSpan={4} align="center" style={{ border: "none", padding: "20px" }}>
                                                    <Typography><EmptyData /></Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            <TableRow key={index}>
                                                <TableCell >{index + 1}</TableCell>
                                                <TableCell align="center">{item?.referenceText}</TableCell>
                                                <TableCell align="center">{item?.stampDuty}</TableCell>
                                                <TableCell align="right">
                                                    <Tooltip title="Edit">
                                                        <EditIcon
                                                            color="success"
                                                            sx={{ "&:hover": { cursor: "pointer" } }}
                                                            onClick={() => {
                                                                setUpdateId(item.referenceId);
                                                                setGetDataFromID(item.referenceId);
                                                                setOpenModel(true);
                                                            }}
                                                        />
                                                    </Tooltip>
                                                    <Tooltip title="Delete">
                                                        <DeleteIcon
                                                            color="error"
                                                            sx={{ "&:hover": { cursor: "pointer" } }}
                                                            onClick={() => {

                                                                setDeleteID(item.referenceId);
                                                                setGetDataFromID(item.referenceId)
                                                                setOpenModel(true);
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </>
                                ))}
                            </TableBody>
                            {Loading && <TableSkeleton noOfColumns={4} noOfLines={5} />}
                        </Table>
                        {getdata.length === 0 && !Loading && <EmptyData />}
                    </TableContainer>
                </CardBody>
            </Card>

            {openModel && (
                <StampDutyModal
                    setOpenModel={setOpenModel}
                    getdata={getdata}
                    updateId={updateId}
                    setUpdateId={setUpdateId}
                    togglebutton={togglebutton}
                    settogglebutton={settogglebutton}
                    deleteId={deleteId}
                    setDeleteID={setDeleteID}
                    setSuccessMessage={setSuccessMessage}
                    setErrorMessage={setErrorMessage}
                    getdataFromID={getdataFromID}
                    setGetDataFromID={setGetDataFromID}
                    setGetData={setGetData}
                />
            )}

            {successMessage && (
                <CustomSnackbar
                    open={successMessage !== ""}
                    message={successMessage}
                    handleClose={() => setSuccessMessage("")}
                    variant="success"
                />
            )}

              
                 {errorMessage && (
                    <CustomSnackbar
                      open={errorMessage !== ""}
                      message={errorMessage}
                      handleClose={() => setErrorMessage("")}
                      variant="error"
                    />
                  )}
                        
        </>
    );
};

export default StampDutySetting;
